import axios from "axios";
import { baseUriSF, baseUriSFV2 } from "src/config";
import { msalInstance } from "src/lib/msal";
import { ServiceFailureRecord } from "src/types/customer-service-failures/service-failure";

const serviceFailureApiInstance = axios.create({
    baseURL: baseUriSF,
});

serviceFailureApiInstance.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export async function getServiceFailures(queryString: string) {
    const response = await serviceFailureApiInstance.get(
        `/GetServiceFailures?${queryString}`,
    );

    if (response.data.Status === "error") {
        throw new Error(response.data.Message);
    }

    return response.data.Data as ServiceFailureRecord[];
}

const serviceFailureApiInstanceV2 = axios.create({
    baseURL: baseUriSFV2,
});
// AUTHENTICATION
serviceFailureApiInstanceV2.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export async function getOrderDetails({
    orderNumber,
}: {
    orderNumber: string;
}) {
    const response = await serviceFailureApiInstanceV2.get(
        `/GetOrderDetails/${orderNumber}`,
    );

    if (response.data.Status === "error") {
        throw new Error(response.data.Message);
    }

    return response.data;
}

export async function putApprovalStatus(
    { orderNumber }: { orderNumber: string },
    {
        approvalState,
        approvalNotes,
        submittedBy,
    }: { approvalState: string; approvalNotes: string; submittedBy: string },
) {
    await serviceFailureApiInstance.put(`/${orderNumber}/approval`, {
        ApprovalState: approvalState,
        Notes: approvalNotes,
        SubmittedBy: submittedBy,
    });
}

export async function putServiceFailure(
    { orderNumber }: { orderNumber: string },
    {
        serviceFailureType,
        employeeSubmitted,
        draftComplete,
        atFaults,
    }: {
        serviceFailureType: string;
        employeeSubmitted: boolean;
        draftComplete: boolean;
        atFaults: string;
    },
) {
    const response = await serviceFailureApiInstance.put(`/${orderNumber}`, {
        ServiceFailureType: serviceFailureType,
        Explanation: "",
        EmployeeSubmitted: employeeSubmitted,
        DraftComplete: draftComplete,
        AtFault: atFaults,
    });

    return response.data;
}
